var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivities = function SvgActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 88C65.9721 88 85 68.9721 85 45.5C85 22.0279 65.9721 3 42.5 3C19.0279 3 0 22.0279 0 45.5C0 68.9721 19.0279 88 42.5 88Z",
    fill: "#FBC9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4863 21.8091C13.4863 20.2642 14.7388 19.0117 16.2837 19.0117H68.8571C70.4021 19.0117 71.6545 20.2642 71.6545 21.8091V23.3194V31.2982H13.4863V23.3194V21.8091Z",
    fill: "#E2383E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4863 28.543H71.6545V66.5631C71.6545 69.7341 69.0818 72.3067 65.9109 72.3067H16.7774C14.9598 72.3067 13.4863 70.8332 13.4863 69.0156V67.999V28.543Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2899 33.0898H31.3271V43.0526H41.2899V33.0898Z",
    fill: "#C9EFFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2811 45.2617H19.3184V55.2244H29.2811V45.2617Z",
    fill: "#C9EFFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2899 45.2617H31.3271V55.2244H41.2899V45.2617Z",
    fill: "#E2383E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6893 45.2617H43.7266V55.2244H53.6893V45.2617Z",
    fill: "#C9EFFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8656 45.2617H55.9028V55.2244H65.8656V45.2617Z",
    fill: "#C9EFFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2811 58.0508H19.3184V68.0135H29.2811V58.0508Z",
    fill: "#C9EFFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2899 58.0508H31.3271V68.0135H41.2899V58.0508Z",
    fill: "#C9EFFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6893 58.0508H43.7266V68.0135H53.6893V58.0508Z",
    fill: "#C9EFFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6893 33.0898H43.7266V43.0526H53.6893V33.0898Z",
    fill: "#C9EFFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8656 33.0898H55.9028V43.0526H65.8656V33.0898Z",
    fill: "#C9EFFB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6828,
    cy: 21.6345,
    r: 2.6618,
    fill: "#F15954"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9435,
    cy: 21.6345,
    r: 2.6618,
    fill: "#F15954"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.4948,
    cy: 21.6345,
    r: 2.6618,
    fill: "#F15954"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7807 18.477C55.7807 17.5392 56.5397 16.7803 57.4775 16.7803C58.4153 16.7803 59.1742 17.5392 59.1742 18.477C59.1742 18.6824 59.2199 18.8771 59.3015 19.0516H61.7608C61.8425 18.8771 61.8881 18.6824 61.8881 18.477C61.8881 16.0404 59.9141 14.0664 57.4775 14.0664C55.0409 14.0664 53.0669 16.0404 53.0669 18.477C53.0669 20.9136 55.0409 22.8876 57.4775 22.8876C58.2269 22.8876 58.8344 22.2801 58.8344 21.5307C58.8344 20.7813 58.2269 20.1737 57.4775 20.1737C56.5397 20.1737 55.7807 19.4148 55.7807 18.477Z",
    fill: "#FDBC3B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3188 18.477C41.3188 17.5392 42.0778 16.7803 43.0156 16.7803C43.9533 16.7803 44.7123 17.5392 44.7123 18.477C44.7123 18.6824 44.758 18.8771 44.8396 19.0516H47.2989C47.3805 18.8771 47.4262 18.6824 47.4262 18.477C47.4262 16.0404 45.4522 14.0664 43.0156 14.0664C40.579 14.0664 38.605 16.0404 38.605 18.477C38.605 20.9136 40.579 22.8876 43.0156 22.8876C43.765 22.8876 44.3725 22.2801 44.3725 21.5307C44.3725 20.7813 43.765 20.1737 43.0156 20.1737C42.0778 20.1737 41.3188 19.4148 41.3188 18.477Z",
    fill: "#FDBC3B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9785 18.477C25.9785 17.5392 26.7375 16.7803 27.6752 16.7803C28.613 16.7803 29.372 17.5392 29.372 18.477C29.372 18.6824 29.4176 18.8771 29.4993 19.0516H31.9585C32.0402 18.8771 32.0858 18.6824 32.0858 18.477C32.0858 16.0404 30.1118 14.0664 27.6752 14.0664C25.2387 14.0664 23.2646 16.0404 23.2646 18.477C23.2646 20.9136 25.2387 22.8876 27.6752 22.8876C28.4247 22.8876 29.0322 22.2801 29.0322 21.5307C29.0322 20.7813 28.4247 20.1737 27.6752 20.1737C26.7375 20.1737 25.9785 19.4148 25.9785 18.477Z",
    fill: "#FDBC3B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2085 86.1855C82.3875 86.1855 89.8286 78.7445 89.8286 69.5654C89.8286 60.3864 82.3875 52.9453 73.2085 52.9453C64.0295 52.9453 56.5884 60.3864 56.5884 69.5654C56.5884 78.7445 64.0295 86.1855 73.2085 86.1855Z",
    fill: "#058DE0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2084 83.248C80.764 83.248 86.8891 77.1229 86.8891 69.5673C86.8891 62.0117 80.764 55.8867 73.2084 55.8867C65.6528 55.8867 59.5278 62.0117 59.5278 69.5673C59.5278 77.1229 65.6528 83.248 73.2084 83.248Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3051 83.2441C80.8607 83.2441 86.9858 77.119 86.9858 69.5634C86.9858 62.0078 80.8607 55.8828 73.3051 55.8828C65.7495 55.8828 59.6245 62.0078 59.6245 69.5634C59.6245 77.119 65.7495 83.2441 73.3051 83.2441Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6623 83.2319C66.8561 82.4438 61.5723 76.6604 61.5723 69.6428C61.5723 62.2663 67.4103 56.2534 74.718 55.9724C74.1962 55.912 73.6654 55.8809 73.1274 55.8809C65.5718 55.8809 59.4468 62.006 59.4468 69.5616C59.4468 77.1172 65.5718 83.2422 73.1274 83.2422C73.3065 83.2422 73.4848 83.2387 73.6623 83.2319Z",
    fill: "#D0EAF9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7609 59.3904L72.7023 69.8862C72.7011 70.0914 72.8666 70.2587 73.0718 70.2599L73.126 70.2602C73.3313 70.2613 73.4986 70.0959 73.4997 69.8906L73.5583 59.3948C73.5595 59.1896 73.394 59.0223 73.1888 59.0211L73.1346 59.0208C72.9293 59.0197 72.762 59.1852 72.7609 59.3904Z",
    fill: "#C9EFFB",
    stroke: "#C9EFFB",
    strokeWidth: 0.730356,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0713 70.4044L82.5671 70.463C82.771 70.4642 82.9378 70.6329 82.9367 70.8367L82.9364 70.8909C82.9352 71.0974 82.7665 71.2616 82.5627 71.2605L72.0669 71.2019C71.863 71.2007 71.6962 71.032 71.6973 70.8282L71.6976 70.774C71.6988 70.5701 71.8675 70.4033 72.0713 70.4044Z",
    fill: "#C9EFFB",
    stroke: "#C9EFFB",
    strokeWidth: 0.730356,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2084 72.5232C72.0522 72.5232 71.1128 71.5838 71.1128 70.4276C71.1128 69.2714 72.0522 68.332 73.2084 68.332C74.3646 68.332 75.304 69.2714 75.304 70.4276C75.304 71.5838 74.3646 72.5232 73.2084 72.5232Z",
    fill: "#FDBC3B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.4863,
    y: 28.5547,
    width: 58.2047,
    height: 1.06472,
    fill: "#D0EAF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8286 50.2014L35.1355 52.5083L39.7493 47.8945",
    stroke: "white",
    strokeWidth: 1.12925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgActivities;